// extracted by mini-css-extract-plugin
export default {"content":"WalletHeader_content__7-v+0","name":"WalletHeader_name__yyOeo","memberSince":"WalletHeader_memberSince__ODgAZ"};